<div class="controls">
  <div>
    <button class="icon"><img src="assets/images/back-icon.svg" (click)="backToMissionConfig()"/></button>
  </div>
  <div>
    <button class="icon"><img src="assets/images/add-button.svg" (click)="openParticipantModal()"/></button>
  </div>
</div>

<table>
  <tr class="header">
    <th>{{ 'PARTICIPANT.FIRST_NAME' | translate }}</th>
    <th>{{ 'PARTICIPANT.LAST_NAME' | translate }}</th>
    <th>{{ 'PARTICIPANT.EMAIL' | translate }}</th>
    <!-- <th>{{ 'PARTICIPANT.FUNCTION' | translate }}</th> -->
    <th></th>
  </tr>

  @for (participant of participantsService.participants$ | async; track participant) {
    <tr>
      <td>{{ participant.firstName }}</td>
      <td>{{ participant.lastName }}</td>
      <td>{{ participant.email }}</td>
      <!-- <td>{{ participant.role }}</td> -->
    </tr>
  }
</table>

@if (displayModal) {
  <app-create-participant
    [missionId]="mission.missionId"
    (closeModal)="closeParticipantModal($event)"
  (reloadList)="reloadList()"></app-create-participant>
}
